module.exports = __webpack_public_path__ + "img/exchanged_result.3dce3e4f.png";